import { createRequestFamily } from '../utils/request-atom';
import { IntegrationAbilities } from '../typings/integration-abilities';

export const integrationAbilitiesFamily = createRequestFamily<IntegrationAbilities>();
